import { loaders } from 'entities';

import { Modal, Row } from 'components/Blocks';
import { DownloadFileButton } from 'components/Buttons';
import { FileUpIcon } from 'components/Icons';

import { useOnScreen, useToggleV2 } from 'hooks';

import { fixFileName, truncateText } from 'utils/text';
import { cn } from 'styles';

interface FileDisplayProps {
  url: string;
  type: string;
  name: string;
  filename?: string;

  className?: string;

  maxWidth?: string | number;
}

export function AttachedFile({ name, type, url, className, maxWidth, filename }: FileDisplayProps) {
  const [zoomOn, zoomHandlers] = useToggleV2();

  const isImage = type.startsWith('image/');

  const [isOnScreen, ref] = useOnScreen();

  const { data } = loaders.uploads.getPublicUrl.use({
    blockLoad: !isImage || !isOnScreen,

    params: {
      url,
    },
  });

  const renderImage = isImage && data?.url;

  return (
    <>
      {renderImage && (
        <Modal isOpen={zoomOn} close={zoomHandlers.turnOff} className="max-w-none p-0" allowEscape>
          <img
            src={data?.url || url}
            alt=""
            className="max-h-[90vh] max-w-[90vw] rounded-md object-cover"
          />
        </Modal>
      )}

      <Row
        className={cn('rounded-md', renderImage ? '' : 'border px-3 py-2', className)}
        gap="2"
        styles={{ maxWidth }}
        flexWrap="wrap"
        ref={ref}
      >
        {renderImage ? (
          <button
            className="size-full rounded-md transition-opacity hover:opacity-65"
            onClick={zoomHandlers.turnOn}
          >
            <img src={data?.url || url} alt="" className="size-full rounded-md object-cover" />
          </button>
        ) : (
          <>
            <FileUpIcon size={16} />

            <span className="px-1 text-center text-xxs">{truncateText(fixFileName(name), 85)}</span>

            <DownloadFileButton
              url={url}
              name={name}
              filename={filename}
              className="ml-auto [&_svg]:!size-3"
            />
          </>
        )}
      </Row>
    </>
  );
}
